import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Helpers from '../../utils/helpers';
import RenderInBody from '../hoc/RenderInBody';
import styles from './popover.css';
require('../../utils/ie11pollyfills');

export default class Popover extends Component {
	constructor (props) {
		super(props);
		this.popoverRef = null;
		this.target = null;
		this.windowResizeTimeout = false;
		this.windowResizeDelay = 300; // delay after window resize  is "complete" to run callback
		this.popoverId = Helpers.getComponentId('popover');
		this.setPopoverRef = this.setPopoverRef.bind(this);
		this.documentEventHandler = this.documentEventHandler.bind(this);
		this.windowResizeEventHandler = this.windowResizeEventHandler.bind(this);
		this.windowBlurEventHandler = this.windowBlurEventHandler.bind(this);
		this.setFocusOnPopover = this.setFocusOnPopover.bind(this);
	}

	/**
	 * set focus on popover div
	 */
	setFocusOnPopover () {
		if (this.popoverRef) {
			this.popoverRef.focus();
		}
	}

	componentDidMount () {
		this.target = document.querySelector('#' + this.props.target);
	}

	componentDidUpdate() {
		this.removeEventListeners();
		if(this.props.show){
			this.addEventListeners();
		}
	}

	setPopoverRef (elm) {
        this.popoverRef = elm;
		if(this.props.style.left === undefined && this.props.style.top === undefined){
			this.positionPopover(this.props.placement);
		}
	}

	getLeftCoordinates (scrollTop, offsetMargin, vCenter, targetRect) {
		const defaultSpace = window.innerWidth - targetRect.left;
		const posTop = scrollTop + vCenter - this.popoverRef.offsetHeight / 2 + 'px';
		const posLeft = (targetRect.left + window.pageXOffset - this.popoverRef.offsetWidth) + 'px - ' + offsetMargin;
		const popoverWH = this.popoverRef.clientWidth;
		const remainSpace = targetRect.left;
		this.positionChevron(`${styles.popoverLeft}`, `${styles.popoverRight}`);
		return {posTop, posLeft, popoverWH, remainSpace, defaultSpace};
	}

	getRightCoordinates (scrollTop, offsetMargin, vCenter, targetRect) {
		const posTop = scrollTop + vCenter - this.popoverRef.offsetHeight / 2 + 'px';
		const defaultSpace = targetRect.left;
		const posLeft = (targetRect.left + window.pageXOffset + this.target.offsetWidth) + 'px + ' + offsetMargin;
		const popoverWH = this.popoverRef.clientWidth;
		const remainSpace = window.innerWidth - (defaultSpace + this.target.offsetWidth);
		this.positionChevron(`${styles.popoverRight}`, `${styles.popoverLeft}`);
		return {posTop, posLeft, popoverWH, remainSpace, defaultSpace};
	}

	getTopCoordinates (scrollTop, offsetMargin, hCenter, targetRect) {
		const posTop = (scrollTop + targetRect.top - this.popoverRef.offsetHeight) + 'px - ' + offsetMargin;
		const posLeft = hCenter - this.popoverRef.offsetWidth / 2 + 'px';
		const popoverWH = this.popoverRef.clientHeight;
		const defaultSpace = window.innerHeight - targetRect.top;
		const remainSpace = targetRect.top;
		this.positionChevron(`${styles.popoverTop}`, `${styles.popoverBottom}`);
		return {posTop, posLeft, popoverWH, remainSpace, defaultSpace};
	}

	getBottomCoordinates (scrollTop, offsetMargin, hCenter, targetRect) {
		const winHeight = window.innerHeight;
		const defaultSpace = targetRect.top;
		const posTop = (scrollTop + defaultSpace + this.target.offsetHeight) + 'px + ' + offsetMargin;
		let posLeft = hCenter - this.popoverRef.offsetWidth / 2;
		const popoverWH = this.popoverRef.clientHeight;
		const remainSpace = winHeight - (defaultSpace + this.target.offsetHeight);
		this.positionChevron(`${styles.popoverBottom}`, `${styles.popoverTop}`);
		let rightAdjustmentNeeded = (posLeft+this.popoverRef.clientWidth)>(window.innerWidth+window.pageXOffset);
        if(rightAdjustmentNeeded){
            let popLft = window.innerWidth+window.pageXOffset-this.popoverRef.offsetWidth-5;
            posLeft=popLft+'px';
            let se = document.createElement('style'),
				ranCl = "chevron-adjust"+Math.floor(Math.random()*10000);
            this.popoverRef.classList.add(ranCl);
            let lft = targetRect.left+window.pageXOffset+targetRect.width/2-popLft,
				css = ['.',ranCl,':before,.',ranCl,':after{left:',lft,'px!important}'].join('');
            se.type = 'text/css';
            if (se.styleSheet){
                se.styleSheet.cssText = css;
            } else {
                se.appendChild(document.createTextNode(css));
            }

            document.body.appendChild(se);
        }else posLeft+='px';

		return {posTop, posLeft, popoverWH, remainSpace, defaultSpace};
	}

	getBottomLeftCoordinates (scrollTop, offsetMargin, hRight, targetRect) {
		const pageWidth = document.querySelector('#main-div').clientWidth;

		const winWidth = window.innerWidth;
		const defaultSpace = targetRect.top;
		const posTop = (scrollTop + defaultSpace + this.target.offsetHeight) + 'px + ' + offsetMargin;
		let posLeft = 0;
		const hDelta = window.innerWidth - (hRight + this.popoverRef.clientWidth) + (pageWidth-winWidth) - 4;
		if(hDelta < 0){
			posLeft = hRight + hDelta;
		} else {
			posLeft = hRight;
		}

		this.popoverRef.style.top = 'calc(' + posTop + ')';
		this.popoverRef.style.left = 'calc(' + (posLeft - this.target.offsetWidth) + 'px)';
	}

    getBottomRightCoordinates (scrollTop, offsetMargin, hLeft, targetRect) {
		const posTop = (scrollTop + targetRect.top + this.target.offsetHeight) + 'px + ' + offsetMargin;
		let posLeft = hLeft - this.popoverRef.clientWidth + window.pageXOffset;

		if(posLeft < 0){
			posLeft = 0;
		}
		this.popoverRef.style.top = 'calc(' + posTop + ')';
		this.popoverRef.style.left = 'calc(' + (posLeft+ this.target.offsetWidth) + 'px)';
	}

    getTopRightCoordinates (scrollTop, offsetMargin, hLeft, targetRect) {
        const posTop = (scrollTop + targetRect.top - this.popoverRef.offsetHeight - 5) + 'px + ' + offsetMargin;
        let posLeft = hLeft - this.popoverRef.clientWidth;

        if(posLeft < 0){
            posLeft = 0;
        }
        this.popoverRef.style.top = 'calc(' + posTop + ')';
        this.popoverRef.style.left = 'calc(' + (posLeft+ this.target.offsetWidth) + 'px)';
	}

    getTopLeftCoordinates (scrollTop, offsetMargin, hRight, targetRect) {
        const pageWidth = document.querySelector('#main-div').clientWidth;

        const winWidth = window.innerWidth;
        const defaultSpace = targetRect.top;
        const posTop = (scrollTop + defaultSpace - this.popoverRef.offsetHeight - 5) + 'px + ' + offsetMargin;
        let posLeft = 0;
        const hDelta = window.innerWidth - (hRight + this.popoverRef.clientWidth) + (pageWidth-winWidth) - 4;
        if(hDelta < 0){
            posLeft = hRight + hDelta;
        } else {
            posLeft = hRight;
        }

        this.popoverRef.style.top = 'calc(' + posTop + ')';
        this.popoverRef.style.left = 'calc(' + (posLeft - this.target.offsetWidth) + 'px)';
	}

	documentEventHandler (ev) {
		let e = ev || event;
        let charCode = e.which || e.keyCode;
		// close popover on click of outside the popover and its target and on escape key (27) press.
		if (((this.shouldCloseOnExternalClick(e)) || (e.type === 'keydown' && charCode === 27))
			&& (!this.props.persistDismiss || (this.props.persistDismiss && !e.target.closest(this.props.persistDismiss)))) {
			this.removeEventListeners();
			this.props.onDismiss();
		}
	}

	shouldCloseOnExternalClick (ev) {
        let e = ev || event;
		return (e.type === 'mousedown' &&
		this.props.closeOnExternalClick &&
		e.target.closest('#' + this.popoverId) === null &&
		e.target.closest('#' + this.target.id) !== this.target);
	}

	windowResizeEventHandler () {
		clearTimeout(this.windowResizeTimeout);
		// start timing for window resize "completion"
		this.windowResizeTimeout = setTimeout(() => {
			this.positionPopover(this.props.placement);
		}, this.windowResizeDelay);
	}

	windowBlurEventHandler () {
		if(this.props.closeOnExternalClick) {
			this.removeEventListeners();
			this.props.onDismiss();
		}
	}

	positionPopover (placement) {
		const targetElm = this.target;
		if(this.popoverRef && targetElm){
		const targetRect = targetElm.getBoundingClientRect();
		const vCenter = targetRect.top + targetElm.offsetHeight / 2 + window.pageYOffset;
		const hCenter = targetRect.left + targetElm.offsetWidth / 2 + window.pageXOffset;
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
		const offsetMargin = this.props.chevron ? '0.65rem' : '0.2rem';
		let posCords = {};

			if (placement === 'top') {
				posCords = this.getTopCoordinates(scrollTop, offsetMargin, hCenter, targetRect);
			} else if (placement === 'right') {
				posCords = this.getRightCoordinates(scrollTop, offsetMargin, vCenter, targetRect);
			} else if (placement === 'left') {
				posCords = this.getLeftCoordinates(scrollTop, offsetMargin, vCenter, targetRect);
			} else if (placement === 'bottom') {
				posCords = this.getBottomCoordinates(scrollTop, offsetMargin, hCenter, targetRect);
			} else if (placement === 'bottom-left'){
				return this.getBottomLeftCoordinates(scrollTop, offsetMargin, targetRect.right, targetRect);
			} else if (placement === 'bottom-right'){
				return this.getBottomRightCoordinates(scrollTop, offsetMargin, targetRect.left, targetRect);
			} else if (placement === 'top-right'){
				return this.getTopRightCoordinates(scrollTop, offsetMargin, targetRect.left, targetRect);
			} else if (placement === 'top-left'){
				return this.getTopLeftCoordinates(scrollTop, offsetMargin, targetRect.right, targetRect);
			} else {
				return;
			}
			// reposition if default remaining space is less than the required space by popover.
			if (posCords.popoverWH > posCords.remainSpace && posCords.defaultSpace > posCords.popoverWH) {
				return this.positionPopover(Popover.placementMap.get(placement));
			} else {
				this.popoverRef.style.top = 'calc(' + posCords.posTop + ')';
				this.popoverRef.style.left = 'calc(' + posCords.posLeft + ')';
			}
		}

	}

	positionChevron (add, remove) {
		if (this.props.chevron) {
			this.popoverRef.classList.add(add);
			this.popoverRef.classList.remove(remove);
		}
	}

	removeEventListeners () {
		if (this.props.closeOnExternalClick) {
			document.removeEventListener('mousedown', this.documentEventHandler);
			window.removeEventListener('blur', this.windowBlurEventHandler);
		}
		document.removeEventListener('keydown', this.documentEventHandler);
		window.removeEventListener('resize', this.windowResizeEventHandler);
	}

	addEventListeners () {
		if (this.props.closeOnExternalClick) {
			document.addEventListener('mousedown', this.documentEventHandler, false);
			window.addEventListener('blur', this.windowBlurEventHandler, false);
		}
		window.addEventListener('resize', this.windowResizeEventHandler, false);
		document.addEventListener('keydown', this.documentEventHandler, false);
	}

	/**
	 * add opacity transition effect to backdrop while closing.
	 */
	addTransition (css) {
		if (this.popoverRef) {
			this.popoverRef.classList.add(css);
		}
	}

	stopPropagation (e) {
		e.stopPropagation();
	}

	render () {
		if (!this.props.show) {
			this.addTransition(`${styles.fadeout}`);
			return null;
		}
		const {className, show, placement, fixed, chevron, children, closeOnExternalClick, onDismiss, persistDismiss, ...other} = this.props;
		return (
			<RenderInBody id={this.popoverId} delayBeforeUnmount={300}>
				<div
					ref={this.setPopoverRef}
					tabIndex="0"
					className={`${fixed ? 'fixed' : 'absolute'} bg-white zindex6 ${styles.popover} ${className} ${!this.props.chevron && styles.noChevron}`}
					{...other}
					onClick={this.stopPropagation}
				>
					{this.props.children}
					<div tabIndex="0" style={{ width: '0px' }} onFocus={this.setFocusOnPopover} />
				</div>
			</RenderInBody>
		);
	}
}

Popover.propTypes = {
	/**
	 * popover placement.
	 */
	placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'bottom-right']),
	/**
	 * Target element id on click of which popover will be shown.
	 */
	target: PropTypes.string.isRequired,
	/** To show and hide the popover.
	 *
	 */
	show: PropTypes.bool,
	/** To be at fixed position w.r.t viewport.
	 *
	 */
	fixed: PropTypes.bool,
	/**
	 * Css classes
	 */
	className: PropTypes.string,
	/**
	 * To show/hide chevron
	 */
	chevron: PropTypes.bool,
	/**
	 * children
	 */
	children: PropTypes.node,
	/**
	 * Call back function on close of the popover
	 */
	onDismiss: PropTypes.func,
	/**
	 * Should popover be closed on click of outside of popover and it's target (i.e. document).
	 */
	closeOnExternalClick: PropTypes.bool,
	/**
	 * Style object to be applied for popover.
	 */
	style: PropTypes.object,

	persistDismiss: PropTypes.string
};

Popover.defaultProps = {
	show: false,
	placement: 'bottom',
	fixed: false,
	chevron: false,
	className: '',
	children: null,
	closeOnExternalClick: true,
	onDismiss: () => {
	},
	style: {}
};

Popover.placementMap = new Map([['top', 'bottom'], ['bottom', 'top'], ['left', 'right'], ['right', 'left']]);
